import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { RootState } from "../../app/store";
import "./style.scss";
import SubscriptionPaymentItem from "../../components/SubscriptionPaymentItem";
import { navigateToPage, setSelectedStatisticItem } from "../../redux/slices/windowSlice";
import Lottie from "lottie-react";
import lottie from "../../assets/output.json";

const StatisticItems = () => {
    const dispatch = useAppDispatch();
    
    const { statisticItems } = useAppSelector(
        (state: RootState) => state.windowSlice
    );

    const handleSelectItem = (item) => {
        dispatch(setSelectedStatisticItem(item));
        dispatch(navigateToPage("subscription_info"));
    }

    return (
        <div className="my-subscriptions">
            <div className="my-subscriptions_container">
                <div className="my-subscriptions_wrapper">
                    {statisticItems.length > 0 && (
                        statisticItems.map((item, index) => (
                            <SubscriptionPaymentItem key={index} item={item} onClick={handleSelectItem} />
                        ))
                    )}

                    {statisticItems.length === 0 && (
                        <div className="my-subscriptions_empty">
                            <div className="my-subscriptions_empty_lottie">
                                <Lottie
                                    animationData={lottie}
                                    style={{ width: "100%", height: "100%" }}
                                />
                            </div>

                            <span className="my-subscriptions_empty_text">
                                За сегодня тут ещё ничего нет.
                            </span>
                    
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default StatisticItems;
